<template>
    <div>
        <div class="mb-5 d-print-none sammio__webcontent" v-html="infoContent">
        </div>
        <div class="col-md-12 px-0 d-print-none" :class="inputClearHiddenClass">

            <label class="v-label" for="sammioSearchField">{{ $t('sammio.search_field_placeholder') }}</label>
            <div class="col-md-12 pl-0 pt-1 d-none d-sm-block sammio-cardfield__selection">
                <div class="row" v-if="filtersReady && !isMobile">
                    <span class="sammio-panels__title col-xl-4 col-lg-12 pt-1">{{ $t('sammio.target_fields') }}</span>
                    <span class="col-xl-8 col-lg-12">
                        <div class="row">
                            <v-checkbox
                                    v-model="activeCardFieldFilters"
                                    :label="$t('sammio.' + filters.cardField.subsection.label)"
                                    @change="refreshData"
                                    :value="filters.cardField.subsection.value"
                                    :multiple=true
                                    class="col-lg-4 col-md-12"
                            >
                            </v-checkbox>
                            <v-checkbox
                                    v-model="activeCardFieldFilters"
                                    :label="$t('sammio.' + filters.cardField.justification.label)"
                                    @change="refreshData"
                                    :value="filters.cardField.justification.value"
                                    :multiple=true
                                    class="col-lg-4 col-md-12"
                            >
                            </v-checkbox>
                            <v-checkbox
                                    v-model="activeCardFieldFilters"
                                    :label="$t('sammio.' + filters.cardField.guidance.label)"
                                    @change="refreshData"
                                    :value="filters.cardField.guidance.value"
                                    :multiple=true
                                    class="col-lg-4 col-md-12"
                            >
                            </v-checkbox>
                        </div>
                    </span>
                </div>
            </div>

            <v-text-field
                    v-model="activeQ"
                    v-if="filtersReady"
                    @keydown.enter="executeSearch(false)"
                    @mouseover="isHovering = 'search'"
                    @mouseleave="isHovering = ''"
                    @focus="isHovering = 'search'"
                    @keypress="isHovering = 'search'"
                    full-width
                    id="sammioSearchField"
                    single-line
            >
              <template slot="append" v-if="activeQ.length > 0">
                <v-btn
                    @click="executeSearch(true)"
                    class="btn--nostyle v-input__icon--append"
                >
                  <x-icon size="1.25x"></x-icon>
                  <span class="sr-only">{{ $t('sammio.clear') }}</span>
                </v-btn>
              </template>
              <template slot="append">
                <v-btn
                    @click="executeSearch(false)"
                    class="btn--nostyle v-input__icon--append"
                >
                    <span v-if="isHovering === 'search'">
                      <sammio-icon-search-highlight></sammio-icon-search-highlight>
                    </span>
                  <span v-else>
                    <sammio-icon-search></sammio-icon-search>
                  </span>

                   <span class="sr-only">{{ $t('sammio.do_search') }}</span>
                </v-btn>
              </template>
            </v-text-field>
        </div>
        <div class="mt-3 d-print-none">
            <div v-if="lastQ !== ''" class="mb-3" aria-live="polite">
                <span class="d-inline-block mr-3">{{ $t('sammio.keyword')}}</span><span><strong>{{ lastQ }}</strong></span>
                <div v-if="synonyms" class="mb-3">
                    <span class="d-inline-block mr-3">{{ $t('sammio.searched_with_synonym')}}</span><span v-for="(synonym, q) in synonyms" :key="q">
                        <strong>{{ synonym }}&nbsp;</strong>
                    </span>
                </div>
            </div>
            <div v-if="getActiveFilters() && getActiveFilters().length > 0" class="mb-3">
                <sammio-active-filter
                        v-for="activeFilter in getActiveFilters()"
                        :categoryId="activeFilter"
                        :key="activeFilter"
                >
                </sammio-active-filter>

                <div class="col-md-12 align-end">
                    <v-btn class="btn btn-link align-right mt-3 p-0" @click="clearAllFilters">{{ $t('sammio.clear_filters') }}</v-btn>
                </div>
            </div>
        </div>
        <v-divider class="d-print-none"></v-divider>
        <div class="mb-3 row d-print-none">
            <div class="col-md-12">
              <div class="mb-3">
                <p class="small">{{
                    $t('sammio.show_x_results', {
                    count: totalResults
                    })
                    }}</p>
              </div>
              <div class="sammio__actions--bookmarks" id="sammio__actions--bookmarks-add-all">
                <v-btn class="btn btn-link align-right" @click="bookmarkAllCards()">
                  <favourite-all></favourite-all>
                    {{ $t('sammio.bookmarks.add_all') }}
                    <sammio-dialog
                            :text="dialogConfirmText"
                            :show-dialog="showConfirmDialog"
                            activatorId="sammio__actions--bookmarks-add-all"
                            v-on:close-dialog="handleCloseDialog"
                    ></sammio-dialog>
                </v-btn>
              </div>
            </div>
        </div>
        <v-container>
          <v-pagination
              v-if="totalResults > pageSize && paginated === true"
              :length="paginationLength"
              total-visible="7"
              v-model="currentPage"
              :next-aria-label="$t('sammio.pagination.next')"
              :previous-aria-label="$t('sammio.pagination.previous')"
              :page-aria-label="$t('sammio.pagination.goto_page')"
              :wrapper-aria-label="$t('sammio.pagination.wrapper')"
              :current-page-aria-label="$t('sammio.pagination.current')"
              class="mb-3 d-print-none"
          >
          </v-pagination>
            <v-row v-for="(card, index) in visibleCards" :key="card.key + '-' + index + '-' + card.title ">
                <sammio-card
                    :id="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}`"
                    :cardProps="card"
                    :index="index"
                    :searchTerms="searchTerms"
                    css-class="sammio-card bg-white p-3 mb-4 w-100"
                    v-on:click-subsection-link="onClickSubsectionLink($event, index)"
                    v-on:click-attachment-link="onClickAttachmentLink($event, index)"
                >
                </sammio-card>
            </v-row>

          <v-pagination
                v-if="totalResults > pageSize"
                :length="paginationLength"
                total-visible="7"
                v-model="currentPage"
                :next-aria-label="$t('sammio.pagination.next')"
                :previous-aria-label="$t('sammio.pagination.previous')"
                :page-aria-label="$t('sammio.pagination.goto_page')"
                :wrapper-aria-label="$t('sammio.pagination.wrapper')"
                :current-page-aria-label="$t('sammio.pagination.current')"
                class="d-print-none"
            >

            </v-pagination>
        </v-container>
    </div>
</template>

<script>

    import SammioCard from '../SammioCard'
    import SammioActiveFilter from "./SammioActiveFilter"
    import { XCircleIcon, SearchIcon, XIcon } from 'vue-feather-icons'
    import SammioIconSearch from "../icons/Search"
    import SammioIconSearchHighlight from "../icons/SearchHighlight"
    import {i18n } from "../../translations/i18n"
    import * as http from "../../store/http"
    import {fetchSubsection} from "../../store/helpers"
    import {fetchAttachment} from "../../store/helpers"
    import FavouriteAll from "../icons/FavouriteAll"
    import SammioDialog from "../SammioDialog"
    import { mapGetters } from 'vuex'

    export default {

        name: "SammioSearchMain",
        data() {
            return {
                lastQ: '',
                paginated: false,
                hover: '',
                infoContent: this.getInfoContent(),
                showConfirmDialog: false
            }
        },
        components: {
            SammioDialog,
            FavouriteAll,
            SammioCard,
            SammioActiveFilter,
            XCircleIcon,
            SearchIcon,
            XIcon,
            SammioIconSearch,
            SammioIconSearchHighlight
        },
        methods: {
            refreshData() {
                this.$store.dispatch('fetchCards', this.currentPage - 1)
                this.lastQ = this.activeFilters.q
            },
            getActiveFilters() {
                let categories = this.filters.active.categories
                if (categories) {
                    return categories.flat()
                }
                return categories
            },
            clearAllFilters() {
                this.$store.dispatch('clearAllFilters')
            },
            executeSearch(clear = false) {
                if (clear) {
                    this.$store.dispatch('updateQ', '')
                }
                this.currentPage = 1
                this.refreshData()
            },
            isInputClearVisible() {
                return this.lastQ && (this.lastQ.length > 0)
            },
            getSubsectionCallback(payload) {
                this.$store.dispatch('addVisibleCard', payload)
            },
            getAttachmentCallback(payload) {
              this.$store.dispatch('addVisibleCard', payload)
            },
            onClickSubsectionLink(eventPayload, index) {
                fetchSubsection(this.$store, eventPayload.indices, index, this, this.getSubsectionCallback)
            },
            onClickAttachmentLink(eventPayload, index) {
              fetchAttachment(this.$store, eventPayload, index, this, this.getAttachmentCallback)
            },
            getInfoContent() {
                http.get('/get-content', this.$store.state.portletId, {info: 'search'})
                    .then(response => {
                        this.infoContent = response.data.content
                    })
                    .catch(error => {
                        this.error = true
                        this.$store.dispatch('setErrorMessages', {
                            hasErrors: true,
                            data: {type: 'cards', code: '', text: i18n.t('sammio.errors.common_error')}
                        })
                    })
            },
            handleCloseDialog(confirmed, activatorId) {
                if (confirmed) {
                    this.bookmarkAllCards(true)
                } else {
                    this.showConfirmDialog = false
                }

                // Focus button element after returning from dialog
                var buttonElement = jQuery("#" + activatorId).find('button')[0];
                this.$nextTick(function() {
                    jQuery(buttonElement).focus();
                });
            },
            bookmarkAllCards(confirmed = false) {
                if ((this.totalResults <= 20) || confirmed) {
                    this.showConfirmDialog = false
                    this.$store.dispatch('addAllBookmarks')
                } else {
                    this.showConfirmDialog = true
                }
            }
        },
        computed: {
            ...mapGetters({
                filtersReady: 'getFiltersReady',
                filters: 'getFilters',
                visibleCards: 'getVisibleCards',
                activeFilters: 'getActiveFilters',
                searchMeta: 'getSearchMeta',
                getCurrentPage: 'getSearchCurrentPage',
                isMobile: 'getIsMobile'
            }),
            activeCardFieldFilters: {
                set(cardFields) {
                    this.$store.dispatch('updateActiveCardFields', cardFields)
                },
                get() {
                    return this.activeFilters.cardFields
                }
            },
            dialogConfirmText() {
                return i18n.t('sammio.bookmarks.prompt_add_x_to_bookmarks', { count: Math.min(300, this.totalResults)})
            },
            inputClearHiddenClass() {
                if (this.isInputClearVisible()) {
                    return ''
                }
                return 'input-clear-hidden'
            },
            inputFieldIcon() {
                if (this.isInputClearVisible()) {
                    return ''
                }
                return '$search'
            },
            totalResults() {
                return this.searchMeta.total
            },
            synonyms() {
                return this.searchMeta.synonyms
            },
            searchTerms() {
                let searchTerms = this.lastQ;
                if (this.synonyms && (Object.values(this.synonyms).length > 0)) {
                    searchTerms = searchTerms + ' ' + Object.values(this.synonyms).join(' ');
                }
                return searchTerms;
            },
            activeQ: {
                set(q) {
                    this.$store.dispatch('updateQ', q)
                },
                get() {
                    return this.activeFilters.q
                }
            },
            currentPage: {
                set(value) {
                    this.$store.dispatch('setSearchCurrentPage', {page: value} )
                },
                get() {
                    return this.getCurrentPage
                }
            },
            pageSize() {
                return this.searchMeta.pageSize > 0 ? this.searchMeta.pageSize : 1
            },
            paginationLength() {
                return Math.ceil(this.searchMeta.total / this.pageSize)
            },
            isHovering: {
                get: function () {
                    return this.hover
                },
                set: function (newValue) {
                    this.hover = newValue
                }
            },
            locale() {
                return i18n.locale
            }
        },
        watch: {
            visibleCards: function(val) {
                this.$nextTick(function() {
                    MathJax.typeset(['.v-card__text'])
                })
            },
            currentPage: function(val) {
                this.refreshData()
                this.paginated = true
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
            },
            locale: function(val) {
                this.executeSearch(true)
                this.getInfoContent()
            }
        }

    }
</script>

<style lang="scss">

    .v-input__slot {
        // fix buttons on FF and Safari
        [type="button"] {
            -webkit-appearance: none;
        }
    }

    div.input-clear-hidden {
        .v-input__icon--clear {
            display: none;
        }
    }
</style>
